/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import DocumentLibraryIcon from "../../../assets/icons/library_documents.svg2";
import HelpButton from "../../HelpContent/HelpButton";
import NewFeature from "../../Builder/Components/NewFeature";

export default function DocumentLibraryWidget() {
  const [period, setPeriod] = useState("");
  const [total, setTotal] = useState(0);
  const [activeProcessCount, setActiveProcessCount] = useState(0);
  const [processCount, setProcessCount] = useState(0);

  return (
    <div className="position-relative px-2 d-flex flex-column h-100">

      <div className="d-flex p-3 align-items-center widget-header">
        <DocumentLibraryIcon width={20} className="white opacity-50" />
        <h6 className="m-0 mx-2 small fw-bold">DOCUMENT</h6>
        <HelpButton helpKey="widget-document" iconClassName="white" />
      </div>
      <NewFeature>
        <div className="mt-2">
          {[
            {
              label: (
                <div className="opacity-50">
                  <Link className="btn p-0 text-white" to="/library/document">
                    Document{" "}
                  </Link>
                </div>
              ),
              value: `${total}`,
            },

            {
              label: <div className="opacity-50">Active components</div>,
              value: `${total}`,
            },
            {
              label: (
                <div className="opacity-50">
                  <Link
                    className="btn p-0 text-white"
                    to="/reporting/processes"
                  >
                    Running processes
                  </Link>
                </div>
              ),
              value: <div>{activeProcessCount}</div>,
            },
            {
              label: (
                <div className="opacity-50">
                  <Link
                    className="btn p-0 text-white"
                    to="/reporting/processes"
                  >
                    All processes
                  </Link>
                </div>
              ),
              value: <div>{processCount}</div>,
            },
          ].map((r, i) => (
            <React.Fragment key={i}>
              <hr className="m-1" />
              <div className="d-flex justify-content-between px-3">
                <span className="fw-bold p-1">{r.label}</span>
                <h3 className="fw-bold m-0 p-1">{r.value}</h3>
              </div>
            </React.Fragment>
          ))}
        </div>
        <div className="flex-grow-1" />

        <div className="px-3">
          <hr />
          <button
            type="button"
            className={`btn btn-light btn-sm px-2 py-0 rounded-pill text-purple fw-bold mx-1 ${
              period === "" ? "" : "opacity-50"
            }`}
            onClick={() => setPeriod("")}
          >
            ALL
          </button>
          <button
            type="button"
            className={`btn btn-light btn-sm px-2 py-0 rounded-pill text-purple fw-bold mx-1 ${
              period === "today" ? "" : "opacity-50"
            }`}
            onClick={() => setPeriod("today")}
          >
            DAY
          </button>
          <button
            type="button"
            className={`btn btn-light btn-sm px-2 py-0 rounded-pill text-purple fw-bold mx-1 ${
              period === "week" ? "" : "opacity-50"
            }`}
            onClick={() => setPeriod("week")}
          >
            WEEK
          </button>
          <button
            type="button"
            className={`btn btn-light btn-sm px-2 py-0 rounded-pill text-purple fw-bold mx-1 ${
              period === "month" ? "" : "opacity-50"
            }`}
            onClick={() => setPeriod("month")}
          >
            MONTH
          </button>
        </div>
        <div className="p-2">{datePeriod().html}</div>
      </NewFeature>
    </div>
  );
}
